import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { COLORS } from '../../constants/constants';  // Assuming COLORS is defined
import {
  Chart as ChartJS,
  ArcElement,  // Needed for doughnut chart
  Tooltip,
  Legend,
  Title,
} from 'chart.js';

// Register the necessary components for Doughnut chart
ChartJS.register(
  ArcElement,  // Register ArcElement for doughnut chart
  Tooltip,
  Legend,
  Title
);

const DoughnutChartComponent = ({ data, total }) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false, // Disable aspect ratio to control size manually
    plugins: {
      tooltip: {
        enabled: true,
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        bodyColor: '#fff',
      },
      legend: {
        position: 'right',  // Position the legend on the right side
        labels: {
          boxWidth: 20,  // Set the width of the legend symbol
          padding: 20,   // Add space between the legend items
          usePointStyle: true,  // Use point style instead of box (default)
          font: {
            size: 12,  // Customize font size for the legend
            weight: 'bold',
          },
        },
      },
      // Display total value in the center of the doughnut chart
      datalabels: {
        display: true,
        color: '#fff',
        font: {
          weight: 'bold',
          size: 18,
        },
        formatter: () => total, // Display the total value in the center
      },
    },
    cutout: '60%', // Adjust thickness (larger value for thinner ring)
  };

  // Define the dataset colors (you can adjust this depending on your data)
  const datasetColors = data.datasets[0].data.length === 2
    ? [COLORS.primary, COLORS.secondary] // If 2 segments, use primary and secondary colors
    : [COLORS.profit, COLORS.primary, COLORS.dues]; // For 3 segments, use custom colors

  // Define chart data
  const updatedData = {
    labels: data.labels,
    datasets: [
      {
        label: 'Distribution',
        data: data.datasets[0].data,
        backgroundColor: datasetColors,
        borderWidth: 3,  // Set border width to make it thinner
        hoverOffset: 4,  // Optional: Hover effect for segments
      },
    ],
  };

  return (
    <div style={{ width: '450px', height: '250px' }}> {/* Adjust the width and height */}
      <Doughnut data={updatedData} options={options} />
    </div>
  );
};

export default DoughnutChartComponent;
